module.exports = __webpack_public_path__ + "img/video.920d32c2.png";